import React from 'react';
import { AnnualPlanCard } from './AnnualPlanCard';
import { SeasonalPlanCard } from './SeasonalPlanCard';
import styles from './shared/SharedPlanStyles.module.scss';
import { type AnnualPlanCardProps, type SeasonalPlanCardProps } from './shared/interfaces';
import classNames from 'classnames';

export type PlansProps = {
  annualData: AnnualPlanCardProps;
  seasonalData: SeasonalPlanCardProps;
  componentStyles?: string; // This allow us to add custom wrap class to override the default styles
};

export const PLANS_WRAPPER_ID = 'plans-wrapper-id';

const Plans: React.FC<PlansProps> = ({ annualData, seasonalData, componentStyles }) => {
  const plansOptionsWrapper = classNames(styles.plansOptionsWrapper, componentStyles);

  return (
    <div data-testid={PLANS_WRAPPER_ID} className={plansOptionsWrapper}>
      <AnnualPlanCard {...annualData} />
      <SeasonalPlanCard {...seasonalData} />
    </div>
  );
};

export default Plans;
